<template>
    <div>
        企业详情
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>